import * as React from 'react'

const BAND_HEIGHT = 160

/**
 * Drives the reflective-tape "glint" on the two vertical edge lines: a soft
 * highlight band that sweeps down the line as the page scrolls, like light
 * catching 3M tape as you pass it. Renders nothing itself — it just keeps
 * `--shine-y` (read by `.edge-line::after` in marketing.css) in sync with
 * scroll position, one repeating sweep per viewport-height of scroll.
 */
export function EdgeLineShine() {
  React.useEffect(() => {
    document.documentElement.style.setProperty('--shine-height', `${BAND_HEIGHT}px`)

    let ticking = false

    const update = () => {
      const cycle = window.innerHeight + BAND_HEIGHT
      const y = (window.scrollY % cycle) - BAND_HEIGHT
      document.documentElement.style.setProperty('--shine-y', `${y}px`)
      ticking = false
    }

    const onScroll = () => {
      if (ticking) return
      ticking = true
      window.requestAnimationFrame(update)
    }

    update()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return null
}
